import { render } from "./OnboardingPopup.vue?vue&type=template&id=2e8d8a4f&scoped=true"
import script from "./OnboardingPopup.vue?vue&type=script&lang=js"
export * from "./OnboardingPopup.vue?vue&type=script&lang=js"

import "./OnboardingPopup.vue?vue&type=style&index=0&id=2e8d8a4f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8d8a4f"]])

export default __exports__